import api from "../common/services/liferay/api";
import {Liferay} from "../common/services/liferay/liferay";

export const getCoordinationSettings = async (delta = 10, cur = 1) => {

    let url = `/api/jsonws/invoke`;
    const name = document.getElementById('input').value;

    const resp = await api(url, {
        method: 'POST',
        body: new URLSearchParams({
            cmd: JSON.stringify({
                '/digitalsale.deliverycoordinationsetting/search-data': {'name': name},
            }),
            p_auth: Liferay.authToken
        }),
    });

    const data = await resp.json();

    return JSON.parse(data);
}